// hooks/useMessage.js
import { useState } from 'react';

export const useMessage = () => {
  const [message, setMessage] = useState(null);

  const showMessage = (text, type = 'info', duration = 3000) => {
    setMessage({ text, type });
    setTimeout(() => {
      setMessage(null);
    }, duration);
  };

  const success = (text, duration) => showMessage(text, 'success', duration);
  const error = (text, duration) => showMessage(text, 'error', duration);
  const info = (text, duration) => showMessage(text, 'info', duration);
  const warning = (text, duration) => showMessage(text, 'warning', duration);

  return {
    message,
    showMessage,
    success,
    error,
    info,
    warning,
  };
};